import React, { useEffect, useState } from 'react';
import { firestore, functions } from '../../database/firebase';
import { useStripe } from '@stripe/react-stripe-js';
import ProductSkeleton from '../ProductSkeleton';
import { useNavigate } from 'react-router-dom';

interface Step3Props {
  formData: {
    nombre: string;
    apellidos: string;
    dni: string;
    email: string;
    telefono: string;
    direccion: string;
    municipio: string;
    fechaNacimiento: string;
    observaciones: string;
    clase: string;
    nivel?: string;
    horario?: string;
    instrumento?: string;
    duracion?: string;
    pricingId: string;
    producto: any;
    tipo: string;
    subscriptionPrice: number;
    productoId: number;
  };
}

const Step3: React.FC<Step3Props> = ({ formData }) => {
  const [products, setProducts] = useState<any[]>([])
  const [alertVisible, setAlertVisible] = useState(true);
  const [loading, setLoading] = useState(true)
  const [buttonLoading, setButtonLoading] = useState(false)
  const stripe = useStripe();
  const navigate = useNavigate()

  const matriculacionPrductId = 'prod_QJj4IJwh2EGKws'

  useEffect(() => {
    setProductId()
    
  }, [])

  const handleCheckout = async () => {
    setButtonLoading(true)
    if (!stripe) {
      console.error('Stripe.js ha fallado en cargar.');
      return;
    }
    try {
      const paymentLink = functions.httpsCallable('paymentLink')
      const matriculacionSuccess = await paymentLink(formData)
      window.location.replace(matriculacionSuccess.data.url)
    } catch (error) {
      console.error('Error creando la sesión de Checkout:', error);
    }
  };

  const handleRegistration = () => {
    setButtonLoading(true)
    firestore.collection('alumnos')
    .doc(formData.dni)
    .set({...formData, creationDate: new Date(), fechaNacimiento: new Date(formData.fechaNacimiento)})
    .catch((error: any) => {
      console.log(error);
    }).finally(() => {
      setButtonLoading(false)
      navigate('/success')
    })
  }

  const getProducts = async (pricingPlan: string) => {

    const productsList: any[] = []

    const matriculacionProd = functions.httpsCallable('getProduct')
    const matriculacionProdData = await matriculacionProd(matriculacionPrductId)
    productsList.push(matriculacionProdData.data)

    const planProd = functions.httpsCallable('getProduct')
    const planProdData = await planProd(pricingPlan)

    formData.pricingId = planProdData.data.default_price.id;
    formData.producto = planProdData.data.name
    formData.productoId = planProdData.data.id
    formData.subscriptionPrice = planProdData.data.default_price.unit_amount
    productsList.push(planProdData.data)
    
    localStorage.setItem('formData', JSON.stringify(formData))
    setLoading(false)
    setProducts(productsList)

  }

  const setProductId = () => {
    let pricingPlan= ''
    
    if (formData.clase === 'musica_movimiento') {
      pricingPlan ='prod_QHpzc0j7cxRxSc'
    } else {
      if (formData.clase === 'lenguaje_musical') {
        if (formData.duracion === '20_minutos') {
          pricingPlan ='prod_QJj0MH1xARy2ng'
        } else if ( formData.duracion === '30_minutos') {
          pricingPlan = 'prod_QJj11dSHQNzqod'
        } else if (formData.duracion === '60_minutos') {
          pricingPlan = 'prod_QJj2n44vGDw2v8'
        }
      } else if (formData.clase === 'solo_instrumento') {
        if (formData.duracion === '30_minutos') {
          pricingPlan = 'prod_QJj3xZeAkAMlln'
        } else if (formData.duracion === '60_minutos') {
          pricingPlan = 'prod_QJj4xAR9VhLkwr'
        }
      }
    }
    console.log(pricingPlan);
    
    getProducts(pricingPlan)
  }


  return (
    
    <div className="container mx-auto p-4">
      {loading ? (
        <ProductSkeleton />
      )
      :
      (<div>{formData.tipo !== 'banda' ? (<div>
        {alertVisible && (
          <div className="absolute top-20 z-50 right-4 bg-yellow-100 text-yellow-900 px-4 py-2 rounded shadow-md flex items-center">
            <span className="mr-2">Se te redirigirá a la página de pagos seguros de Stripe</span>
            <button
              className="text-yellow-900 font-bold"
              onClick={() => setAlertVisible(false)}
            >
              ×
            </button>
          </div>
        )}
        <h1 className="text-2xl font-bold mb-4">Resumen de actividades elegidas</h1>
        <div className="bg-white shadow-md rounded-lg overflow-hidden">
          {products.map(product => (
            <div key={product.id} className="flex items-center p-4 border-b">
              <div className="ml-4 flex-1">
                <h2 className="text-lg font-semibold">{product.name}</h2>
                <p className="text-gray-600">{product.description}</p>
                <p className="text-gray-900 font-bold">{product.default_price.unit_amount / 100} € {product.id !== matriculacionPrductId ? '/ mes' : ''}</p>
              </div>
              <div className="ml-4">
                <p className="text-gray-700">Cantidad: 1</p>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-4 flex justify-end">
            {buttonLoading ? (<button disabled type="button" className="py-2.5 px-5 me-2 text-gray-900 bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 inline-flex items-center">
              <svg aria-hidden="true" role="status" className="inline w-4 h-4 me-3 text-gray-200 animate-spin dark:text-gray-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#1C64F2" />
              </svg>
              Cargando...
            </button>) : (<button id='checkoutButton' onClick={handleCheckout} className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="inline w-4 h-4 me-3 text-white ">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
                </svg>
              Proceder al Pago
            </button>)}
        </div>
      </div>) : (<div>
        <h1 className="text-2xl font-bold mb-4">Resumen de actividades elegidas</h1>
        <div className="bg-white shadow-md rounded-lg overflow-hidden">
          {products.map(product => (
            <div key={product.id} className="flex items-center p-4 border-b">
              <div className="ml-4 flex-1">
                <h2 className="text-lg font-semibold">{product.name}</h2>
                <p className="text-gray-600">{product.description}</p>
                <p className="text-gray-900 font-bold">{product.default_price.unit_amount / 100} € {product.id !== matriculacionPrductId ? '/ mes' : ''}</p>
              </div>
              <div className="ml-4">
                <p className="text-gray-700">Cantidad: 1</p>
              </div>
            </div>
          ))}
        </div>
      </div>)}
      <div className="mt-4 flex justify-end">
        {formData.tipo === 'banda' && (<button id='checkoutButton' onClick={handleRegistration} className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="inline w-4 h-4 me-3 text-white ">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
                </svg>
              Matricularte
            </button>)}
            
        </div>
      </div>)}
    </div>
  );
};

export default Step3;
